export enum IconDisplayStyle {
    Default = 'default', // To be defined.

    MaterialIconsOutlined = 'material-icons-outlined'
}
